import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useMutation } from '@apollo/client';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { disableTotpLoginTemplate } from 'apollo/templates/user/mutation.graphql';
import { currentUserVar } from 'apollo/reactive-variables/user';

type DisableGoogleAuthDialogProps = {
    open: boolean;
    onClose: () => void;
};
const DisableGoogleAuthDialog: FC<DisableGoogleAuthDialogProps> = ({ open, onClose }: DisableGoogleAuthDialogProps) => {
    const currentUser = currentUserVar();
    const { t: translate } = useTranslation(['common', 'user-settings']);
    const [isLoading, setIsLoading] = useState(false);
    const { showBoundary } = useDenthubErrorBoundary();

    const [disableTotpLogin] = useMutation(disableTotpLoginTemplate, {
        onCompleted: ({ disableTotpLogin }) => {
            if (disableTotpLogin) {
                currentUser.isTotpEnabled = false;
                currentUserVar(currentUser);
                setIsLoading(false);
                onClose();
            }
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const handleDisableGoogleAuth = () => {
        setIsLoading(true);
        disableTotpLogin();
    };

    return (
        <Dialog fullWidth maxWidth="sm" open={open}>
            <DialogTitle>{translate('user-settings:DISABLE_GOOGLE_AUTH')}</DialogTitle>
            <DialogContent>
                <Box mb={2}>{translate('user-settings:DISABLE_GOOGLE_AUTH_INSTRUCTIONS')}</Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{translate('common:CANCEL')}</Button>
                <LoadingButton
                    color="error"
                    variant="text"
                    onClick={() => handleDisableGoogleAuth()}
                    loading={isLoading}
                >
                    {translate('user-settings:DISABLE_GOOGLE_AUTH')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default DisableGoogleAuthDialog;
